export default {
  "user-sign-up": "Registro de usuario",
  "please-fill-your-data": "Completa los siguientes datos para obtener una cuenta ",
  "dr-now": "Dr Now",
  names: "Nombres",
  "names-placeholder": "Ingresa tus nombres",
  "enter-two-or-more-names": "Agrega si tienes dos o más nombres.",
  "first-surname": "Primer apellido",
  "surname-placeholder": "Ingresa tu apellido",
  "enter-your-first-surname": "Agrega el primer apellido de tu nombre",
  "second-surname": "Segundo apellido",
  "enter-your-second-surname": "Agrega el segundo apellido de tu nombre",
  email: "Correo electrónico",
  "email-placeholder": "Ingresa tu correo",
  "enter-your-work-email": "Agrega tu correo",
  "country-code": "Código",
  country: "País",
  "phone-number": "Número",
  "phone-number-placeholder": "Ingresa tu teléfono",
  "enter-your-phone-number": "Número de contacto",
  password: "Contraseña",
  "password-placeholder": "Ingresa una contraseña segura",
  "enter-a-safe-password-msg": "Para garantizar la seguridad de tu cuenta, crea una contraseña.",
  "at-least-eight-characters": "Mínimo de 8 caracteres",
  "at-least-one-capital-letter": "Al menos una mayúscula",
  "at-least-one-number": "Al menos un número",
  "at-least-one-special-character": "Al menos un carácter especial",
  "password-confirmation": "Confirmar contraseña",
  "password-confirmation-placeholder": "Ingresa de nuevo la contraseña",
  "password-confirmation-msg": "Verifica que tu contraseña coincida",
  "read-and-accept": "He leído y acepto",
  "terms-and-conditions": "Términos y condiciones, Política de privacidad",
  "marketing-notifications-agree": "Acepto el envío de notificaciones de marketing",
  optional: "opcional",
  "previous-fields-are-mandatory": "Estos campos son obligatorios",
  continue: "Registrarme",
  accept: "Aceptar",
  "field-required": "Campo requerido",
  "invalid-email": "Correo electrónico inválido",
  "invalid-phone-number": "Teléfono inválido",
  "invalid-characters": "Caracteres inválidos",
  "invalid-password": "Contraseña inválida",
  "passwords-must-match": "Las contraseñas deben coincidir",
  "service-error": "Error de servicio",
  "please-try-again-later": "Por favor, inténtalo de nuevo",
  processing: "Procesando",
  "sign-up-completed-message": "Gracias por registrarte.",
  "go-to-home": "Ir al inicio",
  "dr-now-doctor-sign-up-email-registered-title": "Error de registro",
  "dr-now-doctor-sign-up-email-registered-message": "El correo electrónico ya ha sido registrado",
  "valid-country-code": "Ingresa un código de país válido",
};
